var map = {
	"./backtop.svg": 4297,
	"./copy.svg": 54,
	"./good.svg": 5376,
	"./qq.svg": 8677,
	"./save.svg": 5936,
	"./search.svg": 696,
	"./share.svg": 9123,
	"./star.svg": 5041,
	"./user.svg": 7838,
	"./wechat.svg": 8690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;